<script>
import _ from 'lodash'
import moment from 'moment'
import EventBus from '@/components/EventBus'
import OrgService from '@/request/user/org'
import OperationService from '@/request/aims/operation'
import md5 from 'js-md5'
export default {
  name: 'AimsWaitList',
  props: {
    hid: {
      type: Number,
      default: 0
    },
    currentDate: {
      type: Number,
      default: moment().startOf('day').valueOf()
    }
  },
  data () {
    return {
      oids: [],
      operationLoading: false,
      waitOperations: [],
      emergencyImage: require('./icons/apply_emergency.png'),
      arrageStore: {}
    }
  },
  computed: {},
  created: function () {
    this.listOids()
    EventBus.$on('websocket-message', this.handleWebsocket)
  },
  mounted: function () {},
  beforeDestroy () {
    EventBus.$off('websocket-message', this.handleWebsocket)
  },
  watch: {
    'hid': function () {
      this.listOids()
    },
    'oids': function () {
      this.listOperation()
    },
    'currentDate': function () {
      this.listOperation()
    }
  },
  methods: {
    listOids () {
      let self = this
      if (!self.hid) {
        self.oids = []
        return
      }
      OrgService.listOrgId({
        pids: self.hid,
        descendant: 1
      }).then(res => {
        self.oids = res.result || []
      })
    },
    listOperation () {
      let self = this
      self.waitOperations = []
      if (_.isEmpty(self.oids) || !self.currentDate) {
        return
      }
      self.operationLoading = true
      let poperation = OperationService.list({
        start: self.currentDate,
        end: moment(self.currentDate).endOf('day').valueOf(),
        orgs: _.join(self.oids),
        status: '3'
      })
      poperation.then(res => {
        let data = res.result || []
        if (_.isEmpty(data)) {
          return
        }
        let wait = []
        _.forEach(data, operation => {
          if (operation.currentState !== 3) {
            return
          }
          if (operation.startTime < this.currentDate || operation.startTime > moment(this.currentDate).endOf('day').valueOf()) {
            return
          }
          wait.push(operation)
        })
        self.waitOperations = _.clone(wait)
      })
      poperation.finally(() => {
        self.operationLoading = false
      })
    },
    saveStore(operation) {
      // let sn = operation.room + ':' + operation.arrangedStartTime;
      let sn = this.md5(operation)
      if (!this.arrageStore[operation.id]) {
        this.arrageStore[operation.id] = []
      }
      if (_.indexOf(this.arrageStore[operation.id], sn) < 0) {
        this.arrageStore[operation.id].push(sn)
      }
    },
    hasStore(operation) {
      let store = this.arrageStore[operation.id]
      if (store) {
        // let sn = operation.room + ':' + operation.arrangedStartTime
        let sn = this.md5(operation)
        let at = _.lastIndexOf(store, sn);
        if (store.length === 0) {
          delete this.arrageStore[operation.id]
        }
        if (at >= 0) {
          return true;
        }
      }
      return false
    },
    md5(operation) {
      let obj = {
        sn: operation.sn,
        currentState: operation.currentState
      }
      return md5(JSON.stringify(obj))
    },
    handleWebsocket (data) {
      if (!data) {
        return
      }
      if (_.isString(data)) {
        data = JSON.parse(data)
      }
      if (!data.source || data.source !== 'eber-system-aims') {
        return
      }
      let operation = data.message
      if (this.hasStore(operation)) {
        return;
      }
      if (data.topic === 'aims-operation-save') {
        this.updateWaitOperation(operation)
      } else if (data.topic === 'aims-operation-delete') {
        this.removeWaitOperation(operation)
      }
    },
    updateWaitOperation (operation) {
      if (!operation) {
        return
      }
      if (operation.currentState !== 3) {
        this.removeWaitOperation(operation)
        return
      }
      if (operation.startTime < this.currentDate || operation.startTime > moment(this.currentDate).endOf('day').valueOf()) {
        this.removeWaitOperation(operation)
        return
      }
      let index = _.findIndex(this.waitOperations, {'id': operation.id})
      if (index < 0) {
        this.waitOperations.push(operation)
      } else {
        this.$set(this.waitOperations, index, operation)
      }
      this.saveStore(operation)
    },
    removeWaitOperation (operation) {
      if (!operation) {
        return
      }
      let wait = _.cloneDeep(this.waitOperations)
      _.remove(wait, item => {
        return item.id === operation.id
      })
      this.waitOperations = _.cloneDeep(wait)
      this.saveStore(operation)
    },
    handleClickOperation (operation) {
      this.$emit('clickOperation', operation)
    }
  },
  filters: {
    timeFilter (value) {
      if (!value || value === '无') {
        return '无'
      }
      return moment(value).format('HH:mm:ss')
    }
  }
}
</script>

<template>
  <div v-loading="operationLoading">
    <vue-draggable :event="item" class="wait-item" v-for="item in waitOperations" :key="item.id" @click.native="handleClickOperation(item)">
      <img v-if="item.emergency === 1" :src="emergencyImage" style="position:absolute;top:10px;left:10px;width:50px;height:50px;opacity:0.2;">
      <table class="table table-condensed border-table">
        <tbody>
          <tr>
            <td width="140">意向时间：{{item.startTime | timeFilter}}</td>
            <td>意向手术间：{{item.roomName}}</td>
            <td>主刀医生：{{item.operatorName}}</td>
          </tr>
          <tr>
            <td rowspan="2">病历号：{{item.historySn}}<br/>床号：{{item.bedid}}<br/>病人姓名：{{item.patName}}<br/>病人年龄：{{item.age}}</td>
            <td>诊断：{{item.diagnoseNames}}</td>
            <td>设备要求：{{item.device}}</td>
          </tr>
          <tr>
            <td>术式：{{item.operatingNames}}</td>
            <td>其它要求：{{item.specialPrepare}}</td>
          </tr>
        </tbody>
      </table>
    </vue-draggable>
  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.wait-item {
  position: relative;
  width: 100%;
  margin-bottom: 10px;
  font-size: 12px;
  line-height: 22px;
  font-weight: 200;
}
.table {
  width: 100%;
  max-width: 100%;
  border-spacing: 0;
  border-collapse: collapse;
  font-size: 12px;
  line-height: 22px;
  font-weight: 200;
  margin-bottom: 20px;
}
table.border-table {
  border: 1px solid #e2e2e4;
}
table.border-table td,
table.border-table th {
  border-bottom: 1px solid #e2e2e4;
  border-left: 1px solid #e2e2e4;
}
table.border-table td:first-child,
table.border-table th:first-child {
  border-left: 0px solid #e2e2e4;
}
.table>tbody>tr>td,
.table>tbody>tr>th,
.table>tfoot>tr>td,
.table>tfoot>tr>th,
.table>thead>tr>td,
.table>thead>tr>th {
  padding: 5px;
  line-height: 1.42857143;
  vertical-align: top;
  border-top: 1px solid #ddd;
}
.table-condensed>tbody>tr>td,
.table-condensed>tbody>tr>th,
.table-condensed>tfoot>tr>td,
.table-condensed>tfoot>tr>th,
.table-condensed>thead>tr>td,
.table-condensed>thead>tr>th {
  padding: 5px;
}
</style>
